import {FormControl, FormLabel, Link} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import clsx from 'clsx';
import markdownit from 'markdown-it';
import markdownitcenter from 'markdown-it-center-text';
import markdownitLink from 'markdown-it-link-attributes';
import React from 'react';
// import Select from '@mui/material/Select';
// import {ThemeProvider} from '@mui/material';

export const RadioB = withStyles((theme) => ({
  root: {
    'padding': '0px 5px 0px 10px',
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {
  },
}))(Radio);

// const inputStyles = makeStyles((theme) => ({
//   root: {
//     '& .MuiInput-input': {
//       color: '#A1A1A1',
//     },
//   },
// }));

const disabledStyles = makeStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-input.Mui-disabled': {
      // color: '#000',
      backgroundColor: '#dadada',
      WebkitTextFillColor: '#000000',
    },
  },
}));

const formLabelStyles = makeStyles((theme) => ({
  root: {
    fontSize: '0.875em',
  },
}));

const makeHelperTextStyles = makeStyles((theme) => ({
  root: {
    color: '#FF0000',           // ヘルパーテキストの文字色
  },
}));

const errorOutLineStyles = makeStyles((theme) => ({
  root: {
    '& label': {
      color: '#FF0000',           // 通常時のタイトルの文字色
    },
    '& label.Mui-focused': {
      color: '#FF0000',           // 入力時のタイトルの文字色
    },
    '& .MuiInput-underline': {
      '&:before': {
        borderColor: '#FF0000',    // 通常時のボーダー色(アウトライン)
      },
      '&:hover:not(.Mui-disabled):before': {
        borderColor: '#FF0000',    // ホバー時のボーダー色(アウトライン)
      },
      '&:after': {
        borderColor: '#FF0000',    // 入力時のボーダー色(アウトライン)
      },
    },
  },
}));

/**
 * 項目がRead Onlyであるかの判定。
 *
 * @param {object} custom 入力項目パラメータ
 * @return {boolean} Read Only項目の場合true
 */
function isReadOnly(custom) {
  const inputProps = custom.InputProps;
  return inputProps && inputProps.readOnly;
}

/**
 * Read Only項目に共通のパラメータ設定を行う。
 *
 * @param {object} custom 入力項目パラメータ
 * @param {object} input 入力情報
 */
function setReadOnlyProps(custom, input) {
  // const classes = inputStyles();
  if (custom == null || !isReadOnly(custom)) {
    return;
  }
  // 文字入力されている場合、文字色をグレーに設定
  if (input.value) {
    // custom['className'] = clsx(custom.className, classes.root);
    custom['className'] = clsx(custom.className);
  }

  // ラベルの位置を固定
  if (!custom.InputLabelProps) {
    custom['InputLabelProps'] = {};
  }
  custom.InputLabelProps.shrink = true;

  // // Placeholderが未設定の場合は共通の値を設定
  // if (!custom.placeholder) {
  //   custom['placeholder'] = '入力不可';
  // }
}

/**
 * エラーテキスト下線のスタイル設定を行う
 *
 * @param {object} custom 入力項目パラメータ
 * @param {object} touched
 * @param {object} error
 * @param {object} warning
 */
function setErrorOutLineProps(custom, touched, error, warning) {
  const outlineStyle = errorOutLineStyles();
  if ((custom != null) &&
      ((touched && error) || warning)) {
    custom['className'] = clsx(custom.className, outlineStyle.root);
  }
}

/**
 * ヘルパーテキストのスタイル設定を行う
 *
 * @param {object} custom 入力項目パラメータ
 * @param {object} touched
 * @param {object} error
 * @param {object} warning
 */
function setFormHelperTextProps(custom, touched, error, warning) {
  const helperTextStyles = makeHelperTextStyles();
  if ((custom != null) &&
      ((touched && error) || warning)) {
    custom['FormHelperTextProps'] = {classes: {root: helperTextStyles.root}};
  }
}

/**
 * disabled項目に共通のパラメータ設定を行う。
 *
 * @param {object} custom 入力項目パラメータ
 * @param {object} input 入力情報
 */
function setDisabledProps(custom) {
  const classes = disabledStyles();
  if (custom == null || !custom.disabled) {
    return;
  }
  custom['className'] = clsx(custom.className, classes.root);
}

export const renderTextField = ({
  input,
  label,
  meta: {touched, error, valid, warning},
  ...custom
}) => {
  // ReadOnlyの場合、パラメータを自動設定
  setReadOnlyProps(custom, input);
  if (isReadOnly(custom)) {
    // 未入力の日付項目の場合、yyyy/mm/ddを表示させないため属性をtextに変更する
    if (!input.value && custom.type == 'date') {
      custom.type = 'text';
    }
  }
  // ヘルパーテキストのスタイル設定を行う
  setFormHelperTextProps(custom, touched, error, warning);
  setErrorOutLineProps(custom, touched, error, warning);
  // disabledのスタイル設定
  setDisabledProps(custom);

  let variant = 'outlined';

  if (isReadOnly(custom)) {
    variant = 'standard';
    // variantがstandardの場合、labelが未設定だとサイズがおかしくなる
    if (!label) {
      label = ' ';
    }
  }
  return (
    <TextField
      variant={variant}
      size={'small'}
      label={label}
      helperText={(touched && error) || warning}
      error={touched && !valid}
      {...input}
      {...custom} />
  );
};

export const renderLink = ({
  input,
  label,
  ...custom
}) => {
  const _classes = formLabelStyles();
  const _className = clsx(custom.className, _classes.root);
  return (
    <FormControl component="fieldset">
      <FormLabel className={_className}>{label}</FormLabel>
      <Link href="#" onClick={(e) => custom.click(e)} variant={'subtitle1'}>{input.value}</Link>
    </FormControl>
  );
};

export const renderSelect = ({
  input,
  label,
  meta: {touched, error, valid, warning},
  ...custom
}) => {
  let isSelect = true;
  // 初期値指定がある場合、初期値を自動設定
  if (custom.defaultValue) {
    input.value = input.value ? input.value : custom.defaultValue;
  }
  // ReadOnlyの場合、パラメータを自動設定
  setReadOnlyProps(custom, input);
  if (isReadOnly(custom)) {
    // 値が未選択の場合、テキストボックスとして描画しPlaceholderを有効にする
    if (!input.value) {
      isSelect = false;
    }
  }
  // ヘルパーテキストのスタイル設定を行う
  setFormHelperTextProps(custom, touched, error, warning);
  setErrorOutLineProps(custom, touched, error, warning);
  // disabledのスタイル設定
  setDisabledProps(custom);

  let variant = 'outlined';

  if (isReadOnly(custom)) {
    variant = 'standard';
    // variantがstandardの場合、labelが未設定だとサイズがおかしくなる
    if (!label) {
      label = ' ';
    }
  }

  return (
    <TextField
      variant={variant}
      size={'small'}
      select={isSelect}
      label={label}
      helperText={(touched && error) || warning}
      error={touched && !valid}
      {...input}
      {...custom} />
  );
};

export const renderSelectMultiLine = ({
  input,
  label,
  meta: {touched, error, valid, warning},
  ...custom
}) => {
  // useStylesの呼び出し数を合わせるため
  setReadOnlyProps(null, null);
  // ヘルパーテキストのスタイル設定を行う
  setFormHelperTextProps(custom, touched, error, warning);
  setErrorOutLineProps(custom, touched, error, warning);
  return (
    <TextField
      variant="outlined"
      size={'small'}
      select={true}
      SelectProps={{
        multiple: true,
        value: (input.value&&input.value.indexOf('') == -1 ? input.value:[] )}}
      label={label}
      helperText={(touched && error) || warning}
      error={touched && !valid}
      {...input}
      {...custom} />
  );
};

export const renderRadioGroup = ({
  input,
  label,
  row,
  meta: {touched, error},
  ...rest
}) => {
  // 初期値指定がある場合、初期値を自動設定
  if (rest.defaultValue) {
    input.value = input.value ? input.value : rest.defaultValue;
  }
  // useStylesの呼び出し数を合わせるため
  setReadOnlyProps(null, null);
  setFormHelperTextProps(null, null, null, null);
  setErrorOutLineProps(null, null, null, null);
  return (
  // <div> {label}
  //   <RadioGroup
  //     row
  //     {...input}
  //     {...rest}
  //   />
  //   {touched && error &&
  //       <Typography variant="caption" color="error">
  //         {error}
  //       </Typography>
  //   }
  // </div>
    <FormControl sx={{marginLeft: '20px'}}>
      <FormLabel sx={{fontSize: '0.8rem'}}>{label}</FormLabel>
      <RadioGroup
        row={row}
        {...input}
        {...rest}
      />
      {touched && error &&
          <Typography variant="caption" color="error">
            {error}
          </Typography>
      }
    </FormControl>
  );
};

export const renderCheckbox = ({input, label, disabled, ...props}) => {
  // useStylesの呼び出し数を合わせるため
  setReadOnlyProps(null, null);
  setFormHelperTextProps(null, null, null, null);
  setErrorOutLineProps(null, null, null, null);
  if (input.value === undefined && input.defaultChecked) {
    return (
      <FormControlLabel
        control={
          <Checkbox
            defaultChecked={input.defaultChecked}
            onChange={input.onChange}
            color="primary"
            disabled={!!disabled}
            {...props}
          />
        }
        label = { label }
      />
    );
  }
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={input.value}
          onChange={input.onChange}
          color="primary"
          disabled={!!disabled}
          {...props}
        />
      }
      label = { label }
    />
  );
};

export const renderNoticeArea = (className, item) => {
  return (
    <div className={className}
      dangerouslySetInnerHTML={
        {
          __html: markdownit()
              .use(markdownitcenter)
              .use(markdownitLink, {
                attrs: {
                  target: '_blank',
                  rel: 'noopener',
                },
              }).render(item),
        }
      }
    />
  );
};
